import {post, get} from './fetch.js'

export default {
  user: {
    ssoLogin(params) {
      return post('/3z-zdry-web/user/ssoLogin', params)
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/service.js